module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/assign.js
// module id = 76
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19